export const MENU_CATEGORIES = [
  { id: "dorroppnare", title: "Dörröppnare", isImplemented: false },

  {
    id: "namnbrickor",
    title: "Namnbrickor",
    isImplemented: true,
  },

  {
    id: "yrkestitelsskyltar",
    title: "Yrkestitelsskyltar",
    isImplemented: true,
    autoOpenSingleProduct: true,
  },

  {
    id: "pendlade-vit",
    title: "Pendlade skyltar - vit bakgrund",
    isImplemented: false,
  },

  {
    id: "pendlade-gron",
    title: "Pendlade skyltar - grön bakgrund",
    isImplemented: false,
  },

  {
    id: "hanvisnings-infoskyltar-vagg",
    title: "Hänvisnings-/infoskyltar på vägg",
    isImplemented: false,
  },

  { id: "taktila-piktogram", title: "Taktila piktogram", isImplemented: false },
  { id: "dorrskyltar", title: "Dörrskyltar", isImplemented: false },

  {
    id: "verksamhetsskylt-inomhus",
    title: "Verksamhetsskylt - inomhus",
    isImplemented: false,
  },

  { id: "inomhusskyltar", title: "Inomhusskyltar", isImplemented: false },
  { id: "kamerabevakning", title: "Kamerabevakning", isImplemented: false },
  { id: "stoldskyddsmarkning", title: "Stöldskyddsmärkning", isImplemented: false },

  {
    id: "vaningsplans-och-hisstavlor",
    title: "Våningsplans- och hisstavlor",
    isImplemented: false,
  },

  { id: "orienteringstavla", title: "Orienteringstavla", isImplemented: false },

  {
    id: "verksamhetsskylt-utomhus",
    title: "Verksamhetsskylt - utomhus",
    isImplemented: false,
  },

  { id: "hanvisningsskylt", title: "Hänvisningsskylt", isImplemented: false },
  { id: "entreskylt", title: "Entréskylt", isImplemented: false },
  { id: "aluminiumskyltar", title: "Aluminiumskyltar", isImplemented: false },
  { id: "profilskylt", title: "Profilskylt", isImplemented: false },
  { id: "profilskylt-storre", title: "Profilskylt - större", isImplemented: false },
  { id: "parkeringsskylt", title: "Parkeringsskylt", isImplemented: false },
  { id: "rokning-forbjuden", title: "Rökning förbjuden", isImplemented: false },
  { id: "roll-up", title: "Roll-up", isImplemented: false },
  { id: "etsfoliering", title: "Etsfoliering", isImplemented: false },
];